<template>
    <v-container fluid class="ma-0 pa-8">
        <v-row class="ma-0 pa-0">
            <v-col cols="auto">
                <span>User Registration</span>
            </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
            <v-spacer></v-spacer>
            <v-col sm="12" md="10">
                <v-data-table
                    :headers="headers"
                    :items="user_registration"
                    :item-class= "getRowClasses"
                    style="width: 100%;"
                    height="500px"
                    :hide-default-footer="user_registration.length < 15"
                    :items-per-page="15"
                >
                </v-data-table>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </v-container>
</template>

<script>
// import {getFirestore, collection, getDocs} from 'firebase/firestore'
// import firebase_app from '../../plugins/firebase.js'
// import {getAuth} from 'firebase/auth';
export default {
    name: 'DigitalRFBasePage',

    components: {
    },

    data: () => ({
        user_registration: [],
        "headers": [
            { "text": "First Name", "value": "first_name", "sortable": false, "desc": "The psychographic profile of the specified target segment."},
            { "text": "Last Name", "value": "last_name", "sortable": false, "desc": "The gender and age of the specified target segment."},
            { "text": "title", "value": "title", "sortable": false, "desc": "Geography in the form of a city or region of the specified target segment."},
            { "text": "organization", "value": "organization", "desc": "Unique amount of people within a specified target segment." },
            { "text": "email", "value": "email", "desc": "The percentage of the specified target segment that overlaps with the primary target audience." },
            { "text": "Date", "value": "date", "desc": "Word-of-mouth index indicating the likelihood that the specified target segment will have social interaction with the primary audience. 100 = status quo. Anything greater than 100 indicates a strong probability. Anything less than 100 indicated a low probability." },
        ]
    }),
    mounted(){
        // this.get_users();
    },
    methods: {
        // get_users: async function(){
        //     const auth = getAuth();
        //     if(auth.currentUser !== null){
        //         this.user_registration = [];
        //         let db = getFirestore(firebase_app);
        //         let users_info = collection(db, "user_registration");
        //         const querySnapshot = await getDocs(users_info);
        //         querySnapshot.forEach((doc) => {
        //             this.user_registration.push(doc.data());
        //         });
        //     }
        // }
    }

}
</script>
